module.exports = __webpack_public_path__ + "img/hair.c79622b2.png";